import React, { useCallback } from "react";
// import "./styles.css";
import { Elements, EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { addDepositStripe } from "../../Services/prod/auth.service";
// import CheckoutForm from "./CheckoutForm";

// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_CLIENT_ID);
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_CLIENT_ID);

const MainStripe = ({ amount, currency, type }) => {

    const fetchClientSecret = useCallback(async () => {
        const data = {
            amount: amount,
            currency: currency,
            type: type
        }
        // Create a Checkout Session
        const response = await addDepositStripe(data)
        console.log(response?.data?.client_secret,"fiufreiu")
        return response?.data?.client_secret    
    }, []);

    const options = { fetchClientSecret };
    return (
        <div>
            <Elements stripe={stripePromise}>
                <div id="checkout">
                    <EmbeddedCheckoutProvider
                        stripe={stripePromise}
                        options={options}
                    >
                        <EmbeddedCheckout />
                    </EmbeddedCheckoutProvider>
                </div>
            </Elements>
        </div>
    );
};



export default MainStripe;
